/** The agent's predicted next user message saved on an assistant message
 *  (`metadata.next_prompt`, already bounded server-side). */
export function nextPromptFromMetadata(
  metadata: Record<string, unknown> | null | undefined,
): string | undefined {
  const value = metadata?.next_prompt;
  return typeof value === "string" && value.trim() ? value : undefined;
}
